// extracted by mini-css-extract-plugin
export default {"container":"OddaniaDetails_container__kAOHM","stage":"OddaniaDetails_stage__RQVxn","btn_zamknij":"OddaniaDetails_btn_zamknij__61RJX","stageBtn":"OddaniaDetails_stageBtn__sRXFY"};